import Vue from 'vue';
import storage from 'local-storage-fallback';
import App from '@src/app';
import store from '@state/store';
import Dolphin from '@loandolphin/dolphin-framework';
import { i18n } from '@src/i18n-setup';
import AOS from 'aos';
import 'aos/dist/aos.css';
import router from '@router';
import '@loandolphin/dolphin-framework/dist/lib/dolphin.css';
import '@components/_common/register';

// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === 'production';
Vue.use(Dolphin);
Vue.prototype.$log = console.info.bind(console);
Vue.prototype.$cdnUrl = process.env.VUE_APP_CDN_URL;

if (!('localStorage' in window)) {
  window.localStorage = storage;
}

const app = new Vue({
  created() {
    AOS.init({
      once: true,
    });
  },
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

// If running inside Cypress
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`
  window.__app__ = app;
}
